/**
 * Ownership check for async thread writes in the agent inbox.
 *
 * Responses and socket events are tagged with the session they belong to. When
 * an agent switches conversations mid-flight, a late arrival must be dropped
 * rather than merged into whichever thread is now on screen.
 *
 * Untagged payloads (no session id available) are allowed through: the caller
 * is responsible for its own guard, e.g. the load sequence token.
 *
 * @param {string | number | null | undefined} sessionId
 * @param {string | number | null | undefined} currentSessionId
 * @returns {boolean}
 */
export function isSameThreadSession(sessionId, currentSessionId) {
  if (sessionId == null || sessionId === "") return true;
  return String(sessionId) === String(currentSessionId ?? "");
}
